import React, { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';

/**
 * Redirect Page for WhatsApp Links
 * 
 * WhatsApp non accetta variabili nel path dell'URL dei pulsanti.
 * Questa pagina riceve il token come query parameter e redirige al form di check-in.
 * 
 * URL WhatsApp: https://hwsmart.it/r?token=ABC123
 * Redirect a: /guest-checkin/ABC123
 */
const RedirectPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const token = searchParams.get('token');
    
    if (token) {
      // Redirige al form di check-in con il token
      navigate(`/guest-checkin/${token}`, { replace: true });
    } else {
      // Se non c'è token, redirige alla homepage
      navigate('/', { replace: true });
    }
  }, [searchParams, navigate]);

  // Mostra un loader durante il redirect
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
        <p className="text-gray-600">Reindirizzamento in corso...</p>
      </div>
    </div>
  );
};

export default RedirectPage;
